import type { ProjectState } from "@livcg/schema";
import { Card } from "../ui/index.js";
import { VarControls } from "./VarControls.js";

type Props = { slug: string; state: ProjectState };

export function TabVar({ slug, state }: Props) {
  return (
    <Card title="VAR review" subtitle="Mavzu → Tekshiruv → Qaror oqimi">
      <VarControls slug={slug} state={state} />
    </Card>
  );
}
